import { h } from 'preact'
import dayjs from 'dayjs'
import removeDatetimeOffset from '../../shared/removeDatetimeOffset'
import cx from '../../shared/classes'
import * as style from './style.css'

interface Props {
    time: string
    isSelected?: boolean
    onClick: () => void
}

const TimeTile: preact.FunctionalComponent<Props> = ({ time, isSelected, onClick }) => {
    const datetimeWithoutOffset = removeDatetimeOffset(time)

    return (
        <div
            className={cx({
                [style.timeTile]: true,
                [style.timeTileSelected]: isSelected,
            })}
            onClick={onClick}
        >
            {dayjs(datetimeWithoutOffset).format('h:mm a')}
        </div>
    )
}

export default TimeTile
